module.exports = __webpack_public_path__ + "e8.no2.df5aacc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e8.no2.jpg
// module id = wqLv
// module chunks = 0